import { ToastrService } from 'ngx-toastr';

export class Utils {

  private static addValueToLine(line: string, field: string, fieldValue: string): string {
    const separator = ',';

    if (line != '') {
      line += separator;
    }

    line += fieldValue;
    return line;
  }

  public static createHyperLinkForDownload(fileName: string, csvContent: string, contentType: string) {
    var hyperLink = document.createElement("a");
    hyperLink.setAttribute('style', 'display:none;');
    document.body.appendChild(hyperLink);
    var blob: Blob = new Blob([csvContent], {type: contentType});
    var url: string = window.URL.createObjectURL(blob);
    hyperLink.href = url;
    hyperLink.download = fileName;
    hyperLink.click();
  }

  public static dataToCsv(dataSet: Object[], fieldsToExclude: string[]) {
    var line: string = '';
    const linebreak = '\r\n';
    var csvContentResult: string = "";
    var headerColumns = Object.keys(dataSet[0]);
    headerColumns = headerColumns.filter(function (column) {
      return !fieldsToExclude.includes(column);
    });

    headerColumns.forEach(headerColumn => {
      line = this.addValueToLine(line, headerColumn, headerColumn);
    })
    csvContentResult += line + linebreak;

    dataSet.forEach(row => {
      var line: string = '';
      var fields: string[] = Object.keys(row);

      fields = fields.filter(function (field) {
        return !fieldsToExclude.includes(field);
      });

      fields.forEach(field => {
        line = this.addValueToLine(line, field, row[field]);
      });

      csvContentResult += line + linebreak;
    });

    this.createHyperLinkForDownload('Export.csv', csvContentResult, 'text/csv');
  }

  public static handleSimpleError(toastrService: ToastrService, error: any): void {
    if (error && error.error && error.error.Message) {
      toastrService.error(error.error.Message);
    } else if (error && error.error && error.error.ExceptionMessage) {
      toastrService.error(error.error.ExceptionMessage);
    } else if (error && error.message) {
      toastrService.error(error.message);
    } else if (error && error.Message) {
      toastrService.error(error.Message);
    } else if (typeof error === 'string') {
      toastrService.error(error);
    } else {
      toastrService.error('An unknown error has occurred.');
    }
  }

  public static handleError(toastrService: ToastrService, error: any): void {
    if (error && error.error && error.error.Message) {
      toastrService.error(error.error.Message);
    } else if (error && error.error && error.error.ExceptionMessage) {
      toastrService.error(error.error.ExceptionMessage);
    } else if (error && error.message) {
      toastrService.error(error.message);
    } else if (error && error.Message) {
      toastrService.error(error.Message);
    } else if (typeof error === 'string') {
      toastrService.error(error);
    } else {
      toastrService.error('An unknown error has occurred.');
    }

    Utils.reportErrorToConsole(error);
  }

  public static reportErrorToConsole(error: any) {
    if (error && error.error instanceof Error) {
      console.error('An error occurred:', error.error.message);
    } else if (error && error.status) {
      console.error(`Backend returned code ${error.status}`, error.error);
    } else {
      console.error('An error occurred:', error);
    }
  }

  public static isValidStringDate(dateString: string) {
    return ((dateString != undefined) && (dateString != "") && (dateString.length == 10))
  }

  // https://stackoverflow.com/questions/10232366/how-to-check-if-a-variable-is-null-or-empty-string-or-all-whitespace-in-javascri
  //
  // Checks the string if undefined, null, not typeof string, empty or space(s)
  // @param {any} str string to be evaluated
  // @returns {boolean} the evaluated result
  public static isStringNullOrWhiteSpace(str): boolean {
    return str === undefined || str === null
      || typeof str !== 'string'
      || str.match(/^ *$/) !== null;
  }

  public static addDays(date: Date, numberOfdays: number): Date {
    date.setDate(date.getDate() + numberOfdays);
    return date;
  }

  public static addWeeks(date: Date, numberOfWeeks: number): Date {
    date.setDate(date.getDate() + numberOfWeeks * 7);
    return date;
  }

  public static addMonths(date: Date, numberOfMonths: number): Date {
    date.setMonth(date.getMonth() + numberOfMonths);
    return date;
  }

  public static addYears(date: Date, numberOfYears: number): Date {
    date.setFullYear(date.getFullYear() + numberOfYears);
    return date;
  }

  public static copyToClipBoard(toastrService: ToastrService, message: string, value: string) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = value;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    if (document.execCommand('copy')) {
      toastrService.info(message);
    }
    document.body.removeChild(selBox);
  }

  public static generateSlug(phrase: string, maxSlugLength: number = 45): string {
    if (!phrase) {
      return '';
    }
    const str = phrase
      .normalize('NFD') // Normalize to decompose accented characters
      .replace(/[\u0300-\u036f]/g, '') // Remove combining diacritical marks
      .toLowerCase()
      .replace(/[^a-z0-9\s-]/g, '') // Remove invalid characters
      .replace(/\s+/g, ' ') // Replace multiple spaces with a single space
      .trim();
    // Trimmed after truncating, matching the server (DataLayer Utils.GenerateSlug). Without it a cut landing on
    // a space became a trailing hyphen here but not server-side, so the same title produced a different slug
    // depending on whether the dashboard submitted one or an API client left it to be derived.
    return str.substring(0, maxSlugLength).trim().replace(/\s/g, '-'); // Replace spaces with hyphens
  }
}
